import Vue from 'vue';
import { BootstrapVue } from 'bootstrap-vue';
import VueScrollTo from 'vue-scrollto';
import VueMeta from 'vue-meta';
import Scrollspy from 'vue2-scrollspy';
import FlagIcon from 'vue-flag-icon';
import VueMasonry from 'vue-masonry-css';
import CrispChat from '@dansmaculotte/vue-crisp-chat';

Vue.use(BootstrapVue);
Vue.use(Scrollspy);
Vue.use(FlagIcon);
Vue.use(VueScrollTo, {
  duration: 2000,
  offset: -60,
  easing: 'ease'
});
Vue.use(VueMeta);
Vue.use(VueMasonry);

Vue.use(CrispChat, {
  websiteId: process.env.CRISP_WEBSITE_ID,
  disabled: true,
  hideOnLoad: true
});

// Register Pro Glass & Shower Doors Corp components, they start with 'proglass-', example: proglass-icon
// Vue.component('proglass-icon', () =>
//  import(/* webpackChunkName: "components/proglass-icon" */ 'components/Icon')
// );
Vue.component('proglass-buttons', () =>
  import(/* webpackChunkName: "components/proglass/buttons" */ 'components/Buttons')
);
Vue.component('proglass-cool-light-box', () =>
  import(/* webpackChunkName: "components/proglass/cool-light-box" */ 'vue-cool-lightbox')
);
Vue.component('proglass-markdown', () =>
  import(/* webpackChunkName: "components/proglass/markdown" */ 'vue-markdown')
);
Vue.component('proglass-page-top', () =>
  import(/* webpackChunkName: "components/proglass/page-top" */ 'components/PageTop')
);
Vue.component('proglass-section', () =>
  import(/* webpackChunkName: "components/proglass/section" */ 'components/Section')
);
Vue.component('proglass-section-header', () =>
  import(/* webpackChunkName: "components/proglass/section-header" */ 'components/SectionHeader')
);
Vue.component('proglass-section-shape', () =>
  import(/* webpackChunkName: "components/proglass/section-shape" */ 'components/SectionShape')
);
Vue.component('proglass-video-section', () =>
  import(/* webpackChunkName: "components/proglass/video-section" */ 'vue-video-section')
);
// ---------------------------------------------------------------------------
// Register bootstrap-vue components, they start with 'b-', example: b-alert
// ---------------------------------------------------------------------------
// Vue.component('b-alert', () =>
//  import(/* webpackChunkName: "components/bootstrap-vue/alert" */ 'bootstrap-vue').then(
//    ({ BAlert }) => BAlert
//  )
// );
